// File: src/pages/admin/UserManagement.jsx
import React, { useState, useEffect } from 'react';

// Modal sửa gói
const EditPlanModal = ({ isOpen, onClose, onSave, currentUser }) => {
    const [plan, setPlan] = useState(currentUser?.subscription?.plan || 'free');
    useEffect(() => { if (currentUser) setPlan(currentUser.subscription?.plan || 'free'); }, [currentUser]);
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl p-6 w-full max-w-sm shadow-xl animate-scaleUp">
                <h3 className="text-xl font-bold mb-4">Cập nhật gói thành viên</h3>
                <p className="text-sm text-gray-500 mb-4">Đang chỉnh sửa cho: <strong>{currentUser.email}</strong></p>
                <div className="space-y-3">
                    {['free', 'pro', 'premium'].map((p) => (
                        <div key={p} onClick={() => setPlan(p)} className={`p-3 rounded-lg border-2 cursor-pointer flex justify-between items-center transition-all ${plan === p ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-blue-200'}`}>
                            <span className="font-bold uppercase text-gray-700">{p}</span>
                            {plan === p && <span className="material-symbols-outlined text-blue-600">check_circle</span>}
                        </div>
                    ))}
                </div>
                <div className="flex gap-3 mt-6">
                    <button onClick={onClose} className="flex-1 py-2 text-gray-600 font-semibold hover:bg-gray-100 rounded-lg">Hủy</button>
                    <button onClick={() => onSave(currentUser._id, plan)} className="flex-1 py-2 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 shadow-md">Lưu thay đổi</button>
                </div>
            </div>
        </div>
    );
};

// Modal sửa thông tin User (Đã fix lỗi chữ trắng)
const EditProfileModal = ({ isOpen, onClose, onSave, currentUser }) => {
    const [formData, setFormData] = useState({ fullName: '', companyName: '', phoneNumber: '' });

    useEffect(() => {
        if (currentUser) {
            setFormData({
                fullName: currentUser.profile?.fullName || '',
                companyName: currentUser.profile?.companyName || '',
                phoneNumber: currentUser.profile?.phoneNumber || ''
            });
        }
    }, [currentUser]);

    if (!isOpen || !currentUser) return null;

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    return (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl animate-scaleUp">
                <h3 className="text-xl font-bold mb-4">Sửa thông tin người dùng</h3>
                <p className="text-sm text-gray-500 mb-4">{currentUser.email}</p>
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">
                            {currentUser.role === 'business' ? 'Tên người đại diện' : 'Họ và tên'}
                        </label>
                        <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} className="w-full border border-gray-300 p-3 rounded-lg text-gray-900 bg-gray-50 focus:outline-none focus:border-blue-500" />
                    </div>
                    
                    {currentUser.role === 'business' && (
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-1">Tên doanh nghiệp</label>
                            <input type="text" name="companyName" value={formData.companyName} onChange={handleChange} className="w-full border border-gray-300 p-3 rounded-lg text-gray-900 bg-gray-50 focus:outline-none focus:border-blue-500" />
                        </div>
                    )}
                    
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Số điện thoại</label>
                        <input type="text" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} className="w-full border border-gray-300 p-3 rounded-lg text-gray-900 bg-gray-50 focus:outline-none focus:border-blue-500" />
                    </div>
                </div>
                <div className="flex gap-3 mt-6">
                    <button onClick={onClose} className="flex-1 py-2.5 text-gray-600 font-semibold hover:bg-gray-100 rounded-lg transition-colors">Hủy</button>
                    <button onClick={() => onSave(currentUser._id, formData)} className="flex-1 py-2.5 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 shadow-md transition-colors">Lưu thông tin</button>
                </div>
            </div>
        </div>
    );
};

export default function UserManagement({ role }) { 
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // States quản lý Modals
    const [editUser, setEditUser] = useState(null); 
    const [editProfileUser, setEditProfileUser] = useState(null); 
    
    const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

    const fetchUsers = async () => {
        const token = localStorage.getItem('skillmatch_token');
        try {
            const res = await fetch(`${API_URL}/api/admin/users?role=${role}`, {
                headers: { 'x-auth-token': token }
            });
            const data = await res.json();
            setUsers(data);
        } catch (e) { console.error(e); } finally { setLoading(false); }
    };

    useEffect(() => { fetchUsers(); }, [role]);

    const toggleStatus = async (id, currentStatus) => {
        const action = currentStatus ? 'KHÓA' : 'MỞ KHÓA';
        if(!window.confirm(`Bạn có chắc chắn muốn ${action} tài khoản này không? User sẽ bị đăng xuất ngay lập tức.`)) return;
        
        const token = localStorage.getItem('skillmatch_token');
        try {
            await fetch(`${API_URL}/api/admin/users/${id}/status`, {
                method: 'PUT',
                headers: { 'x-auth-token': token }
            });
            fetchUsers();
        } catch (e) { alert("Lỗi cập nhật"); }
    };

    const handleDeleteUser = async (id, email) => {
        if(!window.confirm(`⚠️ CẢNH BÁO: Bạn có chắc chắn muốn XÓA VĨNH VIỄN user ${email}? Hành động này không thể hoàn tác!`)) return;
        
        const token = localStorage.getItem('skillmatch_token');
        try {
            const res = await fetch(`${API_URL}/api/admin/users/${id}`, {
                method: 'DELETE',
                headers: { 'x-auth-token': token }
            });
            if(res.ok) {
                alert("Đã xóa người dùng thành công!");
                fetchUsers();
            } else {
                alert("Lỗi khi xóa người dùng");
            }
        } catch (e) { alert("Lỗi kết nối"); }
    };

    const handleUpdatePlan = async (userId, newPlan) => {
        const token = localStorage.getItem('skillmatch_token');
        try {
            const res = await fetch(`${API_URL}/api/admin/users/${userId}/plan`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
                body: JSON.stringify({ plan: newPlan })
            });
            if(res.ok) {
                setEditUser(null);
                fetchUsers();
                alert("Cập nhật thành công!");
            }
        } catch (e) { alert("Lỗi kết nối"); }
    };

    const handleUpdateProfile = async (userId, data) => {
        const token = localStorage.getItem('skillmatch_token');
        try {
            const res = await fetch(`${API_URL}/api/admin/users/${userId}/profile`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
                body: JSON.stringify(data)
            });
            if(res.ok) {
                setEditProfileUser(null);
                fetchUsers();
                alert("Cập nhật thông tin thành công!");
            } else {
                const errorData = await res.json();
                alert(errorData.message || "Lỗi cập nhật");
            }
        } catch (e) { alert("Lỗi kết nối"); }
    };

    return (
        <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Quản lý {role === 'candidate' ? 'Ứng viên' : 'Doanh nghiệp'}</h2>
            
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                <table className="w-full text-left border-collapse">
                    <thead className="bg-gray-50 border-b border-gray-200">
                        <tr>
                            <th className="p-4 font-semibold text-gray-600 text-sm">Thông tin</th>
                            <th className="p-4 font-semibold text-gray-600 text-sm">Gói hiện tại</th>
                            <th className="p-4 font-semibold text-gray-600 text-sm">Trạng thái</th>
                            <th className="p-4 font-semibold text-gray-600 text-sm text-right">Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? <tr><td colSpan="4" className="p-8 text-center">Đang tải...</td></tr> : users.map(user => (
                            <tr key={user._id} className="border-b border-gray-100 hover:bg-gray-50">
                                {/* ✅ CẬP NHẬT PHẦN HIỂN THỊ TÊN CÔNG TY TẠI ĐÂY */}
                                <td className="p-4">
                                    {/* 1. Tên người đại diện / Ứng viên */}
                                    <p className="font-bold text-gray-900 text-base">
                                        {user.profile?.fullName || user.email?.split('@')[0]}
                                    </p>
                                    
                                    {/* 2. Tên Công Ty (Chỉ hiển thị nếu là Doanh nghiệp) */}
                                    {role === 'business' && (
                                        <p className="text-sm font-bold text-blue-600 mt-1 flex items-center gap-1">
                                            🏢 {user.profile?.companyName ? user.profile.companyName : <span className="italic text-gray-400 font-normal">Chưa cập nhật tên công ty</span>}
                                        </p>
                                    )}

                                    {/* 3. Email & Số điện thoại */}
                                    <p className="text-xs text-gray-500 mt-1.5 flex items-center gap-1">
                                        ✉️ {user.email}
                                    </p>
                                    {user.profile?.phoneNumber && (
                                        <p className="text-xs text-gray-500 mt-0.5 flex items-center gap-1">
                                            📞 {user.profile.phoneNumber}
                                        </p>
                                    )}
                                </td>

                                <td className="p-4">
                                    <span 
                                        onClick={() => setEditUser(user)}
                                        className={`px-2 py-1 rounded text-xs font-bold cursor-pointer hover:opacity-80 border ${
                                            user.subscription?.plan === 'premium' ? 'bg-yellow-100 text-yellow-700 border-yellow-200' : 
                                            (user.subscription?.plan === 'pro' ? 'bg-blue-100 text-blue-700 border-blue-200' : 'bg-gray-100 text-gray-600 border-gray-200')
                                        }`}
                                    >
                                        {user.subscription?.plan?.toUpperCase() || 'FREE'} ✎
                                    </span>
                                </td>
                                <td className="p-4">
                                    {user.isActive !== false ? 
                                        <span className="text-green-600 text-sm flex items-center gap-1"><span className="w-2 h-2 bg-green-500 rounded-full"></span> Active</span> : 
                                        <span className="text-red-600 text-sm flex items-center gap-1"><span className="w-2 h-2 bg-red-500 rounded-full"></span> Banned</span>
                                    }
                                </td>
                                <td className="p-4 text-right">
                                    <div className="flex gap-2 justify-end">
                                        <button 
                                            onClick={() => setEditProfileUser(user)}
                                            className="px-3 py-1.5 rounded text-xs font-bold text-white bg-blue-500 hover:bg-blue-600 transition shadow-sm"
                                        >
                                            Sửa
                                        </button>

                                        <button 
                                            onClick={() => toggleStatus(user._id, user.isActive !== false)}
                                            className={`px-3 py-1.5 rounded text-xs font-bold text-white transition shadow-sm ${user.isActive !== false ? 'bg-orange-500 hover:bg-orange-600' : 'bg-green-500 hover:bg-green-600'}`}
                                        >
                                            {user.isActive !== false ? 'Khóa' : 'Mở'}
                                        </button>
                                        
                                        <button 
                                            onClick={() => handleDeleteUser(user._id, user.email)}
                                            className="px-3 py-1.5 rounded text-xs font-bold text-white bg-red-600 hover:bg-red-700 transition shadow-sm"
                                        >
                                            Xóa
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Khai báo Modals */}
            <EditPlanModal isOpen={!!editUser} currentUser={editUser} onClose={() => setEditUser(null)} onSave={handleUpdatePlan} />
            <EditProfileModal isOpen={!!editProfileUser} currentUser={editProfileUser} onClose={() => setEditProfileUser(null)} onSave={handleUpdateProfile} />
        </div>
    );
}